// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2an1P","validationTips":"StatementDescriptor_validationTips__3enax"};